export default {
  name: 'Project planning',
  preview: 'https://cdn.affine.pro/templates/cover/project-planning.png',
  type: 'template',
  content: {
    type: 'page',
    meta: {
      id: 'page:home',
      title: '',
      createDate: 1702541296773,
      tags: [],
    },
    blocks: {
      type: 'block',
      id: 'block:zET2aJVFjS',
      flavour: 'affine:page',
      props: {
        title: {
          '$blocksuite:internal:text$': true,
          delta: [],
        },
      },
      children: [
        {
          type: 'block',
          id: 'block:N8cYzxCp3e',
          flavour: 'affine:surface',
          props: {
            elements: {
              pWyBtXCEs9: {
                type: 'shape',
                xywh: '[-936.2111951133554,-538.3458142160763,1081.4388302959146,1929.6600964667557]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-blue',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'pWyBtXCEs9',
                index: 'Zy',
                seed: 1371964154,
                color: '--affine-palette-line-black',
              },
              pBQzY1pE2A: {
                type: 'text',
                xywh: '[-894.1902075880087,-494.12453840484505,300.5648909105398,68.02312071844209]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Participants',
                    },
                  ],
                },
                color: '--affine-palette-line-navy',
                fontSize: 48.58794337031577,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'pBQzY1pE2A',
                index: 'a2',
                seed: 1094176605,
              },
              BneHPippII: {
                type: 'shape',
                xywh: '[140.3688132174691,-538.3458142160763,1081.4388302959146,1929.6600964667557]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-navy',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'BneHPippII',
                index: 'a3',
                seed: 96561450,
                color: '--affine-palette-line-black',
              },
              du9e8wF6ZJ: {
                type: 'text',
                xywh: '[182.3898027758891,-494.1245384671902,142.11973435817364,72.88191505547366]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Goals',
                    },
                  ],
                },
                color: '--affine-palette-line-white',
                fontSize: 48.58794337031576,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'du9e8wF6ZJ',
                index: 'a4',
                seed: 572113613,
              },
              'EmmIM-vr3h': {
                type: 'shape',
                xywh: '[1216.9488215482938,-538.3457987847758,1081.4388302959146,967.4650551572336]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-purple',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'EmmIM-vr3h',
                index: 'a5',
                seed: 1962863270,
                color: '--affine-palette-line-black',
              },
              GkE3ZHj7k7: {
                type: 'text',
                xywh: '[1258.9698111690586,-494.1245384671902,137.26094002114206,72.88191505547366]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Users',
                    },
                  ],
                },
                color: '--affine-palette-line-white',
                fontSize: 48.58794337031576,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'GkE3ZHj7k7',
                index: 'a6',
                seed: 1767197567,
              },
              '2aNnAHBWt1': {
                type: 'shape',
                xywh: '[1216.9488215482938,421.97292268631315,1081.4388302959146,967.4650551572336]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-blue',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: '2aNnAHBWt1',
                index: 'a7',
                seed: 468015372,
                color: '--affine-palette-line-black',
              },
              Zi5L9bKADi: {
                type: 'text',
                xywh: '[1258.9698087687711,469.61185308138795,324.3245219968578,72.88191505547366]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'User benefits',
                    },
                  ],
                },
                color: '--affine-palette-line-navy',
                fontSize: 48.58794337031576,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'Zi5L9bKADi',
                index: 'a8',
                seed: 1719366953,
              },
              HqPfyGtNLy: {
                type: 'shape',
                xywh: '[2293.5288298791183,-537.9983189207921,1081.4388302959146,1929.6600964667557]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-navy',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'HqPfyGtNLy',
                index: 'a9',
                seed: 705530031,
                color: '--affine-palette-line-black',
              },
              jvVeZuvGwa: {
                type: 'text',
                xywh: '[2335.5498183153263,-493.77704317190603,229.57803242474202,72.88191505547366]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Activities',
                    },
                  ],
                },
                color: '--affine-palette-line-white',
                fontSize: 48.58794337031576,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'jvVeZuvGwa',
                index: 'aA',
                seed: 1523671853,
              },
              rs6Ayp_kwE: {
                type: 'shape',
                xywh: '[3367.6794411037727,-537.9983189207921,1081.4388302959146,1929.6600964667557]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-blue',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'rs6Ayp_kwE',
                index: 'aB',
                seed: 180028404,
                color: '--affine-palette-line-black',
              },
              M0YfeMOWd9: {
                type: 'text',
                xywh: '[3409.700428542458,-493.77704317190603,307.31874181724726,72.88191505547366]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Deliverables',
                    },
                  ],
                },
                color: '--affine-palette-line-navy',
                fontSize: 48.58794337031576,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'M0YfeMOWd9',
                index: 'aC',
                seed: 324688774,
              },
              'be9-iDKvG4': {
                type: 'shape',
                xywh: '[-936.2111123294355,1385.5882513952465,1351.3210018072925,672.1830183966898]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-yellow',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'be9-iDKvG4',
                index: 'aD',
                seed: 193764644,
              },
              ALHUZYJM8R: {
                type: 'shape',
                xywh: '[407.83747438714806,1385.5882513952465,1351.3210018072925,672.1830183966898]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-orange',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'ALHUZYJM8R',
                index: 'aE',
                seed: 764031338,
                color: '--affine-palette-line-black',
              },
              YaX_Q5aifw: {
                type: 'shape',
                xywh: '[1751.8860611037326,1385.5882513952465,1351.3210018072925,672.1830183966898]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-yellow',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'YaX_Q5aifw',
                index: 'aF',
                seed: 1504549631,
              },
              Vmz6zXptWa: {
                type: 'shape',
                xywh: '[3097.7719614343832,1385.5882513952465,1351.3210018072925,672.1830183966898]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-orange',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'Vmz6zXptWa',
                index: 'aG',
                seed: 372259012,
                color: '--affine-palette-line-black',
              },
              EPB0YTtJ0N: {
                type: 'group',
                children: {
                  'affine:surface:ymap': true,
                  json: {
                    pWyBtXCEs9: true,
                    pBQzY1pE2A: true,
                    BneHPippII: true,
                    du9e8wF6ZJ: true,
                    'EmmIM-vr3h': true,
                    GkE3ZHj7k7: true,
                    '2aNnAHBWt1': true,
                    Zi5L9bKADi: true,
                    HqPfyGtNLy: true,
                    jvVeZuvGwa: true,
                    rs6Ayp_kwE: true,
                    M0YfeMOWd9: true,
                    'be9-iDKvG4': true,
                    ALHUZYJM8R: true,
                    YaX_Q5aifw: true,
                    Vmz6zXptWa: true,
                  },
                },
                title: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Group 1',
                    },
                  ],
                },
                id: 'EPB0YTtJ0N',
                index: 'aH',
                seed: 1267487240,
              },
              cYFzz0Z4y3: {
                type: 'text',
                xywh: '[-1896.2623870549764,-324.17145567071265,676.4558193655462,336]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'A project planning template provides a structured framework for outlining goals, defining scope, allocating resources, and setting timelines. \n\nIt typically includes sections for objectives, tasks, deadlines, and responsibilities, streamlining the project planning process.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 34,
                fontFamily: 'blocksuite:surface:Satoshi',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'cYFzz0Z4y3',
                index: 'aX',
                seed: 853422302,
                hasMaxWidth: true,
              },
              l2XbltXRkQ: {
                type: 'text',
                xywh: '[-1896.2623870549764,-452.86212923744733,658.7838745117188,85]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Project management',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 68,
                fontFamily: 'blocksuite:surface:Satoshi',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'l2XbltXRkQ',
                index: 'aY',
                seed: 837887889,
              },
              f_vnsAemnH: {
                type: 'group',
                children: {
                  'affine:surface:ymap': true,
                  json: {
                    cYFzz0Z4y3: true,
                    l2XbltXRkQ: true,
                    'block:R0wbGFYmkR': true,
                  },
                },
                title: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Group 2',
                    },
                  ],
                },
                id: 'f_vnsAemnH',
                index: 'aZ',
                seed: 12503559,
              },
            },
          },
          children: [],
        },
        {
          type: 'block',
          id: 'block:kSiecXOR-N',
          flavour: 'affine:note',
          props: {
            xywh: '[-779.7123192032938,-40.442032368560746,364,346.1796875]',
            background: '--affine-tag-orange',
            index: 'aJV',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 2,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:k9jg7Ti1ha',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:7NrC8vEeHh',
          flavour: 'affine:note',
          props: {
            xywh: '[-549.3640943093344,176.78238878477222,364,346.1796875]',
            background: '--affine-tag-teal',
            index: 'aJ',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 2,
                borderStyle: 'solid',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:6SaTG4do9k',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:sE8irg92ts',
          flavour: 'affine:note',
          props: {
            xywh: '[392.19521546626953,23.937835060841273,364,346.1796875]',
            background: '--affine-background-secondary-color',
            index: 'aK',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:cucke67BID',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:PJpS4XwA8C',
          flavour: 'affine:note',
          props: {
            xywh: '[686.1487491088938,-355.0730231274995,364,346.1796875]',
            background: '--affine-tag-yellow',
            index: 'aL',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:TNDbu7btr0',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:r_L-kpDDbB',
          flavour: 'affine:note',
          props: {
            xywh: '[1569.8860611037326,-255.15441726081872,364,346.1796875]',
            background: '--affine-tag-red',
            index: 'aM',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:QlKaZaBvQS',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:_dpTheh7H8',
          flavour: 'affine:note',
          props: {
            xywh: '[1487.1492412342031,805.154726526921,364,346.1796875]',
            background: '--affine-background-secondary-color',
            index: 'aN',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:278ZJlwkSj',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:At9T0kFbmK',
          flavour: 'affine:note',
          props: {
            xywh: '[1730.2707314973322,645.3846177154558,364,346.1796875]',
            background: '--affine-tag-orange',
            index: 'aO',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:Rivl0CFs7i',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:inkK7D6rjU',
          flavour: 'affine:note',
          props: {
            xywh: '[2464.186199386049,190.70272370690074,364,346.1796875]',
            background: '--affine-tag-purple',
            index: 'aP',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 2,
                borderStyle: 'solid',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:L5yKrizMGi',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:wKVYm2Gpsw',
          flavour: 'affine:note',
          props: {
            xywh: '[2756.7118608200626,23.93783506084128,364,346.1796875]',
            background: '--affine-tag-blue',
            index: 'aQ',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:xASoOXRwoj',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:bMOqSFeE5x',
          flavour: 'affine:note',
          props: {
            xywh: '[3579.0360697959163,3.0788351620244327,364,346.1796875]',
            background: '--affine-tag-orange',
            index: 'aR',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:BidzD-RXBd',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:zBIyJ8_543',
          flavour: 'affine:note',
          props: {
            xywh: '[3899.868875749833,395.75647281570707,364,346.1796875]',
            background: '--affine-background-secondary-color',
            index: 'aS',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:7tTBS3c-Z-',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:sjnhlCco12',
          flavour: 'affine:note',
          props: {
            xywh: '[-745.0338364032766,1287.3505348254732,364,346.1796875]',
            background: '--affine-background-secondary-color',
            index: 'aT',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:mWOQE4jR_j',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:01BPDd8HGW',
          flavour: 'affine:note',
          props: {
            xywh: '[-250.57462774607416,1559.0861403604881,364,346.1796875]',
            background: '--affine-tag-yellow',
            index: 'aU',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:ZRXqWGUU39',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:MmKNfet6IB',
          flavour: 'affine:note',
          props: {
            xywh: '[2306.919927917922,1548.238043700468,364,346.1796875]',
            background: '--affine-tag-yellow',
            index: 'aV',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:ojcMCIXwWx',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:xI2QWxkBws',
          flavour: 'affine:note',
          props: {
            xywh: '[2570.6892162057375,1329.8398793165102,364,346.1796875]',
            background: '--affine-tag-teal',
            index: 'aW',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-sticker',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:V9WYrXvSWE',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
        {
          type: 'block',
          id: 'block:R0wbGFYmkR',
          flavour: 'affine:note',
          props: {
            xywh: '[-1932.890179347341,-516.4700469622377,749.7114039502753,607.495317201419]',
            background: '--affine-tag-blue',
            index: 'aWV',
            hidden: false,
            edgeless: {
              style: {
                borderRadius: 0,
                borderSize: 4,
                borderStyle: 'none',
                shadowType: '--affine-note-shadow-paper',
              },
              collapse: true,
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:PxqxKE5Pg3',
              flavour: 'affine:paragraph',
              props: {
                type: 'text',
                text: {
                  '$blocksuite:internal:text$': true,
                  delta: [],
                },
              },
              children: [],
            },
          ],
        },
      ],
    },
  },
};
